import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const HISTORICALMOOVEAI_LAYER_ID = 'historicalMooveAiLayer';

const layerConfig = {
  title: 'Near Miss Events',
};

function HistoricalMooveAiLayer() {
  const dispatch = useDispatch();
  const { historicalMooveAiLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, historicalMooveAiLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });

  if (historicalMooveAiLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HISTORICALMOOVEAI_LAYER_ID,
      geoColumn: 'h3',
      aggregationExp: 'SUM(total_aeb_activated_count) as Count',

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: historicalMooveAiLayer.visible,
      opacity: historicalMooveAiLayer.opacity,

      getFillColor: colorBins({
        attr: 'Count',
        domain: [10, 25, 50, 1000],
        colors: [
          [251, 230, 197],
          [245, 186, 152],
          [220, 113, 118],
          [200, 88, 108],
          [156, 63, 93],
          [112, 40, 74],
        ],
      }),
      pointRadiusMinPixels: 3.5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HISTORICALMOOVEAI_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      },
    });
  }
}

export default HistoricalMooveAiLayer;
